import { Box } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { Button, IconButton, PersonIcon } from 'ui-components';
import { Feature } from '~/components/Feature';
import { FEATURE_FLAGS } from '~/constants';
import { routes } from '~/core/router';

interface Props {
  slug: string;
}

export const ViewProfileButton: React.FC<Props> = ({ slug }) => {
  const router = useRouter();

  const isSavedListsPage = router.pathname.includes('saved-lists');

  const handleClick = useCallback(() => {
    const url = routes.profileOverview(slug);
    window.open(url, '_blank');
  }, [slug]);

  if (isSavedListsPage) return null;

  return (
    <Feature name={FEATURE_FLAGS.foamAccessibleViewProfileBtn}>
      <Box
        display={{ base: 'block', md: 'none' }}
        track-id="foam-view-profile-button-mobile"
      >
        <IconButton
          aria-label="View Profile"
          icon={<PersonIcon />}
          variant="tertiary"
          onClick={handleClick}
        />
      </Box>
      <Box
        display={{ base: 'none', md: 'block' }}
        track-id="foam-view-profile-button-desktop"
      >
        <Button
          onClick={handleClick}
          aria-label="View Profile"
          variant="tertiary"
          leftIcon={<PersonIcon />}
        >
          View Profile
        </Button>
      </Box>
    </Feature>
  );
};
